<template>
  <div
    v-if="status"
    class="status-label"
    :class="[`--size-${size}`, { '--dot': showDot }]"
    :style="{ '--status-color': '#' + status.hexColor }"
  >
    <span v-if="isLowerCase">{{ status.title?.toLowerCase() }}</span>
    <span v-else>{{ status.title }}</span>
    <i
      v-if="canBeDeleted"
      class="gf-icon gf-icon-x"
      @click="onDeleteClick"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'StatusLabel',
  props: {
    status: {
      type: Object,
      default: null
    },
    size: {
      type: String,
      default: 'sm'
    },
    canBeDeleted: {
      type: Boolean,
      default: false
    },
    isLowerCase: {
      type: Boolean,
      default: true
    },
    showDot: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onDeleteClick() {
      this.$emit('delete', this.status);
    }
  }
};
</script>

<style lang="scss">
$this: '.status-label';

#{$this} {
  width: fit-content;
  height: fit-content;
  min-height: 22px;
  padding: 2px 8px;
  position: relative;
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1;
  color: var(--status-color);
  border: 1px solid var(--status-color);
  border-radius: 14px;
  white-space: nowrap;
  box-sizing: border-box;
  font-family: inherit;

  &.--dot {
    padding: 2px 8px 3px 14px;

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 8px;
      border-radius: 100%;
      width: 5px;
      height: 5px;
      background-color: var(--status-color);
      transform: translateY(-50%) translateX(-50%);
    }
  }

  &.--size-md {
    font-size: 14px;
  }

  & > i {
    margin-left: 2px;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
